"use client";

export type AuthMethod = "mobile" | "email";

interface AuthMethodToggleProps {
  method: AuthMethod;
  onChange: (method: AuthMethod) => void;
}

// Shared "Mobile / Email" pill switcher for the sign-in, sign-in-with-OTP, and
// forgot-password screens. Purely presentational — the parent decides what to
// render below it and how to animate the swap (each screen fades/slides its
// own input group in on method change via the existing animate-in utilities).
export default function AuthMethodToggle({ method, onChange }: AuthMethodToggleProps) {
  const tabCls = (active: boolean) =>
    `flex-1 h-9 rounded-[18px] text-[14px] font-medium schibsted-grotesk transition-colors duration-200 ${
      active ? "bg-[#195AFF] text-white" : "bg-transparent text-[#6C6F87] hover:text-[#195AFF]"
    }`;

  return (
    <div className="mb-[18px] flex rounded-[20px] bg-[#F1F4FB] border-1 border p-[2px]" role="tablist" aria-label="Sign in with">
      <button type="button" role="tab" aria-selected={method === "mobile"} className={tabCls(method === "mobile")} onClick={() => onChange("mobile")}>
        Mobile
      </button>
      <button type="button" role="tab" aria-selected={method === "email"} className={tabCls(method === "email")} onClick={() => onChange("email")}>
        Email
      </button>
    </div>
  );
}
